import { Link, Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import LoginForm from '../../features/auth/LoginForm'

function LoginPage() {
  const { isAuthenticated } = useAuth()

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="login-page auth-page">
      <div className="auth-shell">
        <aside className="auth-brand-panel">
          <Link to="/" className="logo">
            <div className="logo-icon">SSV</div>
            <span>Second Shift Ventures</span>
          </Link>
          <div>
            <span className="auth-eyebrow">Internal workspace</span>
            <h1>Built after hours, operated like it matters.</h1>
            <p>
              Manage products, expenses, meetings, docs, subscriptions, invoices,
              and reports from the same calm workspace.
            </p>
          </div>
          <div className="auth-proof-row">
            <span>Products</span>
            <span>Finance</span>
            <span>Ops</span>
          </div>
        </aside>

        <div className="login-card auth-card animate-fade-in">
          <div className="login-header">
            <Link to="/" className="logo auth-card-logo">
              <div className="logo-icon">SSV</div>
              <span>Second Shift</span>
            </Link>
            <h1>Welcome back</h1>
            <p>Access the internal studio dashboard</p>
          </div>

          <LoginForm />
        </div>
      </div>
    </div>
  )
}

export default LoginPage
